import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SecondaryControlButton from '../../../../../../../services/prints/components/PrintProductConfigurator/components/PrintProductConfiguratorControlsPane/SecondaryControlButton';
import PhotoSlotIcon from '../../../../../../icons/PhotoSlotIcon';
import TextIcon from '../../../../../../icons/TextIcon';
import ShapeIcon from '../../../../../../icons/ShapeIcon';
import StickersIcon from '../../../../../../icons/StickersIcon';
import { CARD_ELEMENT_TYPE } from '../../../../../../../services/cards/constants';

const propTypes = {
  className: PropTypes.string,
  onCardElementCreate: PropTypes.func.isRequired,
  zElementIndexMax: PropTypes.number,
  forCollages: PropTypes.bool.isRequired,
};

const CardDesignerElementsControls = ({
  className,
  onCardElementCreate,
  zElementIndexMax,
  forCollages,
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  const cardElementCreateTypes = [
    {
      label: 'Photo Slot',
      cardElementType: CARD_ELEMENT_TYPE.PHOTO,
      Icon: PhotoSlotIcon,
      input: {
        frame: {
          x: 0.25,
          y: 0.25,
          width: 0.5,
          height: 0.5,
        },
        z_index: zElementIndexMax ?? 1,
      },
    },
    {
      label: 'Text',
      Icon: TextIcon,
      cardElementType: CARD_ELEMENT_TYPE.TEXT,
      input: {
        frame: {
          x: 0.08,
          y: 0.08,
          width: 0.44,
          height: 0.06,
        },
        z_index: zElementIndexMax ?? 2,
      },
    },
    {
      label: 'Rectangle',
      cardElementType: CARD_ELEMENT_TYPE.RECTANGLE,
      Icon: ShapeIcon,
      input: {
        frame: {
          x: 0.25,
          y: 0.25,
          width: 0.5,
          height: 0.5,
        },
        z_index: zElementIndexMax ?? 1,
      },
    },
    {
      label: 'Sticker',
      Icon: StickersIcon,
      cardElementType: CARD_ELEMENT_TYPE.STICKER,
      input: {
        frame: {
          x: 0.45,
          y: 0.45,
          width: 0.1,
          height: 0.1,
        },
        z_index: zElementIndexMax ?? 2,
      },
    },
  ];

  return (
    <div className={classes}>
      <div className="card-designer-layout-controls-list">
        {cardElementCreateTypes.map(cardElementCreateType => {
          // TODO Temporarily hide stickers until fully functional.
          if (cardElementCreateType.label === 'Sticker') {
            return null;
          }

          return (
            <SecondaryControlButton
              key={cardElementCreateType.label}
              className="is-lg"
              title={cardElementCreateType.label}
              icon={<cardElementCreateType.Icon />}
              onClick={() => {
                onCardElementCreate({
                  cardElementConfiguration: forCollages
                    ? {
                        // Event Collages only allow for Photos to be editable.
                        is_editable:
                          cardElementCreateType.cardElementType ===
                          CARD_ELEMENT_TYPE.PHOTO,
                      }
                    : undefined,
                  cardElementType: cardElementCreateType.cardElementType,
                  input: cardElementCreateType.input,
                });
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

CardDesignerElementsControls.propTypes = propTypes;

export default CardDesignerElementsControls;
